import { Component, Input, Output, HostListener, OnChanges, SimpleChanges, EventEmitter } from '@angular/core';
import { IChangeCallback } from '../../_entities';

@Component({
    selector: 'editable-date',
    template: require('./editable-date.template.html'),
    styles: [
        `input, button { margin: -3px -1px; }`,
        `input { margin-left: -5px; padding-left: 3px; padding-right: 3px; }`,
        `button.btn { margin: -10px -2px -6px 3px; padding: 2px 6px; }`
    ]
})
export class EditableDateComponent implements OnChanges {
    private blurTimeout;

    ngOnChanges(changes: SimpleChanges) {
        if (changes['originalValue']) {
            this.editValue = changes['originalValue'].currentValue;
        }
    }
    onFocus() {
        this.editing = true;
    }
    onBlur(ev) {
        if (!this.hasUnsavedChanges) {
            this.onCancel();
        }
    }
    onSave() {
        if (this.hasUnsavedChanges) {
            this.saving = true;
            this.errorMessage = null;
            this.changeCallback.emit({
                id: this.id,
                newValue: this.editValue,
                oldValue: this.originalValue,
                resolve: () => {
                    this.originalValue = this.editValue;
                    this.saving = false;
                    this.editing = false;
                    this.hovering = false;
                    this.hasUnsavedChanges = false;
                },
                reject: (message: string) => {
                    this.saving = false;
                    this.errorMessage = message;
                }
            });
        } else {
            this.onCancel();
        }
    }
    onCancel() {
        this.editValue = this.originalValue;
        this.editing = false;
        this.hovering = false;
        this.hasUnsavedChanges = false;
        this.errorMessage = null;
    }
    onChange() {
        this.errorMessage = null;
        this.hasUnsavedChanges = this.editValue !== this.originalValue;
    }

    @Output() changeCallback = new EventEmitter<IChangeCallback<Date>>();
    @Input() id: string;
    @Input('value') originalValue: Date;
    @HostListener('mouseenter') onMouseEnter() { this.hovering = true; }
    @HostListener('mouseleave') onMouseLeave() { this.hovering = false; }

    editValue: Date;
    editing: boolean;
    hovering: boolean;
    saving: boolean;
    errorMessage: string;
    hasUnsavedChanges: boolean;
}




// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular2-router-loader/src!./TypeScript/shared/components/editable-date.component.ts